import {
  getIntlayer as getIntlayerCore
} from "@intlayer/core";
import {
  intlayerNodePlugins,
  markdownPlugin,
  reactNodePlugins
} from "./plugins.mjs";
const getIntlayer = (key, locale, additionalPlugins) => {
  const plugins = [
    intlayerNodePlugins,
    reactNodePlugins,
    markdownPlugin,
    ...additionalPlugins ?? []
  ];
  return getIntlayerCore(key, locale, plugins);
};
export {
  getIntlayer
};
//# sourceMappingURL=getIntlayer.mjs.map